export const LogoMark = ({ className = "h-9 w-auto" }) => (
  <svg viewBox="0 0 100 148" className={className} fill="none" aria-hidden="true">
    <g stroke="#E8821E" strokeWidth="7">
      <rect x="5" y="5" width="90" height="82" />
      <path d="M16 87 A 34 34 0 0 1 84 87" />
      <path d="M50 53 V 7" />
      <path d="M26 63 L 8 45" />
      <path d="M74 63 L 92 45" />
      <path d="M18 75 L 7 71" />
      <path d="M82 75 L 93 71" />
    </g>
    <g stroke="currentColor" strokeWidth="6">
      <rect x="8" y="93" width="84" height="50" />
      <path d="M36 93 V 143" />
      <path d="M64 93 V 143" />
    </g>
  </svg>
);

export const Logo = ({ className = "", markClass = "h-9 w-auto" }) => (
  <span className={`flex items-center gap-3 ${className}`}>
    <LogoMark className={markClass} />
    <span className="flex flex-col justify-center leading-none">
      <span className="font-serif text-[1.3rem] font-medium uppercase leading-[1.05] tracking-[0.12em]">Dimore</span>
      <span className="font-serif text-[0.92rem] font-medium uppercase leading-[1.05] tracking-[0.24em]">del Sole</span>
    </span>
  </span>
);
